module.exports = __webpack_public_path__ + "img/Gold-Square.5c510a69.png";